import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit {

  @Output() onSave = new EventEmitter<any>();
  @Output() onCloseEvent = new EventEmitter<any>();
  rate: any = 0;
  feedbackRemark: any = '';
  @Input() IsRatingAvailable: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  onClose() {
    this.onCloseEvent.emit();
  }

  onSaveBtnClick(){
    var obj: any = {};
    obj.Rate = this.rate;
    obj.Feedback = this.feedbackRemark;
    this.onSave.emit(obj);
  }

}
